import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import MaintenanceDefault from '@assets/images/common/maintenance-default.ico'
import MaintenanceNew from '@assets/images/common/maintenance-new.ico'
import { Grid, IconButton, SxProps, Theme } from '@mui/material'

import { CustomSvgIcon } from '@components/CustomSvgIcon'

import { useAuth } from '@hooks'
import { ENTITY, USER_ROLES } from '@constants'

import { createRouteStrategy, RouteType } from './strategies/strategyFactory'
import { redirectTo } from './utils'

interface RedirectToConfigButtonProps {
  type: RouteType
  code?: string | null
  entityType?: ENTITY
  searchAssistantId?: string | number
  title?: string
  sx?: SxProps<Theme>
  isOpenNewTab?: boolean
  isWhiteIcon?: boolean
}

const RedirectToConfigButton: React.FC<RedirectToConfigButtonProps> = props => {
  const {
    type,
    code,
    entityType,
    searchAssistantId,
    sx,
    title,
    isOpenNewTab = true,
    isWhiteIcon = false,
  } = props

  const { t } = useTranslation()
  const { hasRole } = useAuth()
  const isAdmin = hasRole([USER_ROLES.ADMIN])
  const navigate = useNavigate()

  const handleRedirect = (event: React.MouseEvent) => {
    event.stopPropagation()
    const strategy = createRouteStrategy(type)
    const path = strategy.getRedirectPath({ code, entityType, searchAssistantId })

    if (!path) {
      console.warn(
        `No redirect path found for type: ${type}, entityType: ${entityType}, code: ${code}`
      )

      return
    }

    if (isOpenNewTab) {
      redirectTo(path)

      return
    }

    navigate(path)
  }

  const handleFocus = (event: React.FocusEvent) => {
    event.stopPropagation()
  }

  if (!isAdmin) {
    return null
  }

  return (
    <Grid item marginLeft='auto'>
      <IconButton
        size={'small'}
        sx={sx}
        title={title ?? t('tooltip.openConfigInNewTabBrowser')}
        onClick={handleRedirect}
        onFocus={handleFocus}
      >
        <CustomSvgIcon
          src={isWhiteIcon ? MaintenanceDefault : MaintenanceNew}
          sx={{ width: 24, height: 24 }}
        />
      </IconButton>
    </Grid>
  )
}

export { RedirectToConfigButton }
